import { CustomModal, NakedTable, FormEntry } from "components";
import { useReducer, memo, useMemo, useCallback, useEffect } from "react";
import { FormGroup } from "./NewEventModal";
import { Button } from "reactstrap";
import { Controller } from "react-hook-form";
import Select from "react-select";

const initialModalState = {
	show: false,
	data: null,
};

const modalAction = {
	open: "OPEN",
	close: "CLOSE",
};

const modalReducer = (state, action) => {
	switch (action.type) {
		case modalAction.open:
			return { ...state, show: true, data: action.payload };
		case modalAction.close:
			return initialModalState;
		default:
			throw new Error("Invalid action");
	}
};

const lessonRecordsColumn = [
	{
		header: "Normal Lessons",
		accessor: (row) => (
			<div>
				<small className="text-muted">{row?.date}</small>
				<div>{row?.name}</div>
			</div>
		),
	},
];
const customLessonRecordsColumn = [
	{
		header: "Custom Lessons",
		accessor: (row) => (
			<div>
				<small className="text-muted">{row?.date}</small>
				<div>{row?.name}</div>
			</div>
		),
	},
];

export const sortLessonRecords = (arr) => {
	return arr.sort((r1, r2) => (r1.date > r2.date ? -1 : r1.date < r2.date ? 1 : 0));
};

const useSelectLessonModal = () => {
	const [modalState, modalDispatch] = useReducer(modalReducer, initialModalState);
	const Component = useCallback(
		({
			errors,
			setCustomLessonEntry,
			isCustomLessonEntry,
			register,
			control,
			lessonOptions,
			isStudentCourseFetching,
			formatGroupLabel,
			sortedLessonRecords,
			sortedCustomRecords,
		}) => {
			return (
				<CustomModal
					show={modalState.show}
					title="Select Lesson"
					hideModal={() => modalDispatch({ type: modalAction.close })}
					light={true}
					triggerAlertMessageWhenClose="Are you sure you want to close? Form entries will be reset."
					buttons={
						<div className="d-flex justify-between">
							<button
								className="btn btn-info"
								onClick={() => {
									modalDispatch({ type: "CLOSE" });
								}}
							>
								Done
							</button>
						</div>
					}
					zIndex={100}
					compact={true}
				>
					<div className="row">
						<div className="col">
							<FormGroup
								error={errors.lesson}
								formLabel="Lesson"
								customEndComponent={
									<Button color="info" size="sm" type="button" onClick={() => setCustomLessonEntry(!isCustomLessonEntry)}>
										{isCustomLessonEntry ? "Normal " : "Custom "} Lesson
									</Button>
								}
							>
								{isCustomLessonEntry ? (
									<FormEntry register={register} formLabel="Lesson Name" placeholder="Custom Lesson Name" name="customLessonName" />
								) : (
									<Controller
										control={control}
										name="lesson"
										render={({ field: { onChange, value, ref } }) => (
											<Select
												inputRef={ref}
												className="react-select info"
												key={value}
												menuPlacement="auto"
												classNamePrefix="react-select"
												value={lessonOptions
													?.reduce((lessons, currentGroup) => lessons.concat(...currentGroup.options), [])
													.find((c) => c.value?.id === value?.id)}
												onChange={(val) => onChange(val.value)}
												isOptionDisabled={(option) => option?.disabled}
												placeholder="Select lesson...."
												options={lessonOptions}
												isDisabled={isStudentCourseFetching}
												formatGroupLabel={formatGroupLabel}
											/>
										)}
									/>
								)}
							</FormGroup>
						</div>
					</div>
					<div className="row">
						<div className="col-sm-6">
							<NakedTable data={sortedLessonRecords} columns={lessonRecordsColumn} maxHeight={400} />
						</div>
						<div className="col-sm-6">
							<NakedTable data={sortedCustomRecords} columns={customLessonRecordsColumn} maxHeight={400} />
						</div>
					</div>
				</CustomModal>
			);
		},
		[modalState.show]
	);
	return [Component, modalState, modalDispatch];
};

export default useSelectLessonModal;
